import React from 'react'
import PropTypes from 'prop-types'
import PracticeSearchBar from './PracticeSearchBar'
import css from './filter.css'
import ProductAndPmsFilter from './ProductAndPmsFilter'
import ActiveCheckbox from './ActiveCheckbox'

const PracticeFilters = ({
  searchFilters: {
    products,
    pmsTypes,
    activeOnly,
  },
  isTopsAdmin,
  numPractices,
  updateSearchString,
  updateProducts,
  updatePmsTypes,
  updateActiveOnly,
}) => (
  <div className={css.container}>
    <PracticeSearchBar
      updateSearchString={updateSearchString}
    />
    <div className={css.filterContainer}>
      <ProductAndPmsFilter
        isTopsAdmin={isTopsAdmin}
        products={products}
        pmsTypes={pmsTypes}
        updateProducts={updateProducts}
        updatePmsTypes={updatePmsTypes}
      />
      <ActiveCheckbox
        onChange={updateActiveOnly}
        active={activeOnly}
      />
    </div>
    <div className={css.numPractices}>
      Practices Found: {numPractices}
    </div>
  </div>
)

PracticeFilters.propTypes = {
  searchFilters: PropTypes.shape({
    searchString: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.string),
    pmsTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  numPractices: PropTypes.number.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  updateSearchString: PropTypes.func.isRequired,
  updateProducts: PropTypes.func.isRequired,
  updatePmsTypes: PropTypes.func.isRequired,
  updateActiveOnly: PropTypes.func.isRequired,
}

export default PracticeFilters



// WEBPACK FOOTER //
// ./src/Dashboard/Filters/index.js